// seller-portal — French. Keys are the English source text.
export default {
  "Language": "Langue",
  "PartHub Seller": "PartHub Vendeur",
  "Dashboard": "Tableau de bord",
  "Inventory": "Stock",
  "Orders": "Commandes",
  "Requests": "Demandes",
  "Reviews": "Avis",
  "Insights": "Analyses",
  "Store": "Boutique",
  "+ Add part": "+ Ajouter une pièce",
  "Seller": "Vendeur",
  "Seller session active": "Session vendeur active",
  "Sign out": "Se déconnecter",
  "Home": "Accueil",
  "Parts": "Pièces",
  "Failed to load compatibility": "Impossible de charger les compatibilités",
  "Preset loaded: {name}": "Modèle chargé : {name}",
  "Make is required.": "La marque est obligatoire.",
  "Model is required.": "Le modèle est obligatoire.",
  "Year start is required.": "L'année de début est obligatoire.",
  "Compatibility row added.": "Compatibilité ajoutée.",
  "Failed to add compatibility row": "Impossible d'ajouter la compatibilité",
  "Add comma-separated years first.": "Ajoutez d'abord des années séparées par des virgules.",
  "Added 1 compatibility row.": "1 compatibilité ajoutée.",
  "Added {n} compatibility rows.": "{n} compatibilités ajoutées.",
  "Added {n} row(s). {failed} duplicate or failed row(s) were skipped.": "{n} ligne(s) ajoutée(s). {failed} doublon(s) ou échec(s) ignoré(s).",
  "No bulk rows were added.": "Aucune ligne ajoutée.",
  "Bulk add failed": "Échec de l'ajout groupé",
  "Compatibility row deleted.": "Compatibilité supprimée.",
  "Failed to delete row": "Impossible de supprimer la ligne",
  "Compatibility row duplicated.": "Compatibilité dupliquée.",
  "Could not duplicate row": "Impossible de dupliquer la ligne",
  "Quick presets": "Modèles rapides",
  "Load common vehicle fitment presets, then fine-tune before saving rows.": "Chargez un véhicule courant, puis ajustez avant d'enregistrer.",
  "Compatibility editor": "Compatibilités véhicule",
  "Add exact fitment rows or bulk-add multiple model years for this part.": "Ajoutez des compatibilités précises ou plusieurs années d'un coup.",
  "Make": "Marque",
  "Model": "Modèle",
  "Engine": "Moteur",
  "Year start": "Année début",
  "Year end": "Année fin",
  "Trim": "Finition",
  "Notes": "Notes",
  "Verified seller fitment": "Compatibilité vérifiée par le vendeur",
  "Saving...": "Enregistrement…",
  "Add single row": "Ajouter une ligne",
  "Bulk add years": "Ajouter plusieurs années",
  "Add multiple year-specific compatibility rows at once using comma-separated years.": "Ajoutez plusieurs années d'un coup, séparées par des virgules.",
  "Years": "Années",
  "Parsed years: {years}": "Années détectées : {years}",
  "none": "aucune",
  "Processing...": "Traitement…",
  "Current compatibility rows": "Compatibilités actuelles",
  "Manage the vehicle rows already linked to this part.": "Gérez les véhicules déjà liés à cette pièce.",
  "Loading compatibility rows...": "Chargement des compatibilités…",
  "No compatibility rows linked yet.": "Aucune compatibilité pour l'instant.",
  "Duplicate": "Dupliquer",
  "Delete": "Supprimer",
  "Checking seller session...": "Vérification de la session…",
  "Message from PartHub:": "Message de PartHub :",
  "Could not load your store status.": "Impossible de charger l'état de votre boutique.",
  "Try again": "Réessayer",
  "Store setup": "Configuration de la boutique",
  "All required steps are done.": "Toutes les étapes obligatoires sont faites.",
  "1 required step left.": "Il reste 1 étape obligatoire.",
  "{n} required steps left.": "Il reste {n} étapes obligatoires.",
  "Store setup progress": "Progression de la configuration",
  "Required": "Obligatoire",
  "Recommended": "Recommandé",
  "Could not load your store status": "Impossible de charger l'état de votre boutique",
  "Offer sent": "Offre envoyée",
  "Accepted 🎉": "Acceptée 🎉",
  "Not selected": "Non choisi",
  "Withdrawn": "Retirée",
  "Please enter your email and password.": "Saisissez votre e-mail et votre mot de passe.",
  "Please enter your name.": "Saisissez votre nom.",
  "Use at least 8 characters for your password.": "Utilisez au moins 8 caractères.",
  "Could not create your account.": "Impossible de créer votre compte.",
  "Seller sign-in failed.": "Échec de la connexion vendeur.",
  "Seller auth": "Espace vendeur",
  "You are already signed in": "Vous êtes déjà connecté",
  "Continue to your dashboard, inventory, or orders.": "Accédez à votre tableau de bord, votre stock ou vos commandes.",
  "Email": "E-mail",
  "Seller account": "Compte vendeur",
  "Role": "Rôle",
  "Continue": "Continuer",
  "Seller auth foundation": "Espace vendeur",
  "Sell your parts on PartHub": "Vendez vos pièces sur PartHub",
  "Sign in to seller portal": "Connexion à l'espace vendeur",
  "Create a free seller account, set up your store in a few minutes, and start answering buyer requests.": "Créez un compte vendeur gratuit, configurez votre boutique en quelques minutes et répondez aux demandes des acheteurs.",
  "Access your dashboard, inventory, orders, media tools, and store settings.": "Accédez à votre tableau de bord, stock, commandes, photos et réglages.",
  "Seller workflow": "Votre activité",
  "Manage your inventory from one place.": "Gérez votre stock au même endroit.",
  "Upload media and attach images to parts.": "Ajoutez des photos à vos pièces.",
  "Review orders and store settings.": "Suivez vos commandes et réglages.",
  "Sign in": "Se connecter",
  "Create seller account": "Créer un compte vendeur",
  "Create your seller account": "Créez votre compte vendeur",
  "Seller sign in": "Connexion vendeur",
  "Next you'll set up your store. PartHub reviews new stores before their parts go live.": "Vous configurerez ensuite votre boutique. PartHub vérifie les nouvelles boutiques avant la mise en ligne.",
  "Use your seller account credentials to continue.": "Utilisez vos identifiants vendeur.",
  "Your name": "Votre nom",
  "Phone (optional)": "Téléphone (facultatif)",
  "Password": "Mot de passe",
  "Creating account…": "Création du compte…",
  "Signing in…": "Connexion…",
  "Create account": "Créer un compte",
  "Active Parts": "Pièces actives",
  "Total Orders": "Commandes",
  "Pending Orders": "Commandes en attente",
  "Avg Rating": "Note moyenne",
  "Seller dashboard": "Tableau de bord vendeur",
  "Welcome back, {name}": "Bon retour, {name}",
  "Welcome back": "Bon retour",
  "Review store activity, inventory health, orders, and quick actions from one place.": "Activité, stock, commandes et actions rapides au même endroit.",
  "+ Add new part": "+ Ajouter une pièce",
  "View orders": "Voir les commandes",
  "Quick actions": "Actions rapides",
  "Jump directly into the most common seller workflows.": "Accédez directement aux actions les plus courantes.",
  "+ Create new part": "+ Nouvelle pièce",
  "Upload media": "Ajouter des photos",
  "Manage inventory": "Gérer le stock",
  "Store settings": "Réglages de la boutique",
  "Recent orders": "Commandes récentes",
  "Quick preview of the newest seller-side order activity.": "Aperçu des dernières commandes.",
  "Loading dashboard activity...": "Chargement de l'activité…",
  "Order": "Commande",
  "Buyer": "Acheteur",
  "No recent orders yet. New seller orders can appear here once order activity grows.": "Aucune commande récente. Vos nouvelles commandes apparaîtront ici.",
  "View all orders →": "Toutes les commandes →",
  "Low stock parts": "Pièces en stock faible",
  "Suggested next steps": "Prochaines étapes",
  "Add more parts to increase storefront coverage.": "Ajoutez des pièces pour être plus visible.",
  "Upload better product images to improve listing quality.": "Ajoutez de meilleures photos pour améliorer vos annonces.",
  "Complete store settings to strengthen seller presence.": "Complétez les réglages de votre boutique.",
  "Portal scope": "Espace vendeur",
  "Ready to expand": "Prêt à évoluer",
  "Foundation active": "Actif",
  "Failed to load insights": "Impossible de charger les analyses",
  "High missed demand detected": "Forte demande non satisfaite",
  "Buyers are searching for \"{query}\" and not finding results. Strong opportunity to add inventory for {vehicle}.": "Des acheteurs cherchent « {query} » sans résultat. Belle opportunité d'ajouter du stock pour {vehicle}.",
  "unlabeled part": "pièce sans nom",
  "target makes": "marques ciblées",
  "target models": "modèles ciblés",
  "Add matching part": "Ajouter la pièce",
  "Some listings have no compatibility data": "Des annonces sans compatibilité",
  "{n} listing(s) currently have zero compatibility rows. These parts may rank weaker and convert worse for vehicle-aware buyers.": "{n} annonce(s) sans aucune compatibilité. Elles sont moins bien classées et se vendent moins.",
  "Improve inventory": "Améliorer le stock",
  "Low stock risk on active inventory": "Risque de rupture de stock",
  "{n} listing(s) are running low on stock. Replenishing them early reduces missed orders and keeps search coverage stable.": "{n} annonce(s) bientôt en rupture. Réapprovisionnez tôt pour ne pas perdre de commandes.",
  "Review inventory": "Voir le stock",
  "Vehicle niche worth targeting": "Véhicule à cibler",
  "One of the strongest buyer demand signals is {vehicle}. Prioritize fitment-rich stock for this vehicle niche.": "{vehicle} fait partie des véhicules les plus demandés. Priorisez du stock compatible.",
  "Create targeted listing": "Créer une annonce ciblée",
  "No critical recommendation yet": "Aucune recommandation pour l'instant",
  "Your insights are loading normally, but there is not enough demand data yet to produce a high-confidence seller recommendation.": "Pas encore assez de données de demande pour une recommandation fiable.",
  "Add new part": "Ajouter une pièce",
  "Seller insights": "Analyses vendeur",
  "Understand demand, missed searches, and which vehicle niches are worth stocking.": "Comprenez la demande, les recherches sans résultat et les véhicules à stocker.",
  "Total parts": "Pièces",
  "All seller listings": "Toutes vos annonces",
  "Active parts": "Pièces actives",
  "Currently live in the marketplace": "En ligne actuellement",
  "Pending parts": "Pièces en attente",
  "Listings waiting for approval": "Annonces en attente de validation",
  "Order items": "Articles commandés",
  "Demand already converted into orders": "Demande transformée en commandes",
  "Recommended actions": "Actions recommandées",
  "What you should do next based on real marketplace demand signals.": "Ce qu'il faut faire selon la demande réelle.",
  "Top buyer demand": "Recherches les plus fréquentes",
  "The most common query demand flowing through the marketplace.": "Les recherches les plus fréquentes sur la plateforme.",
  "No demand signals yet.": "Pas encore de données.",
  "{n} searches": "{n} recherches",
  "Avg. results in market: {n}": "Résultats moyens : {n}",
  "Missed demand": "Demande non satisfaite",
  "Searches with zero results. These are stocking opportunities.": "Recherches sans résultat : des opportunités de stock.",
  "No missed demand captured yet.": "Aucune demande non satisfaite.",
  "No keyword": "Sans mot-clé",
  "{n} misses": "{n} sans résultat",
  "any make": "toute marque",
  "any model": "tout modèle",
  "any year": "toute année",
  "Top vehicle demand": "Véhicules les plus recherchés",
  "Vehicle combinations buyers search for most.": "Les véhicules les plus recherchés.",
  "No vehicle demand data yet.": "Pas encore de données véhicule.",
  "year unspecified": "année non précisée",
  "Inventory snapshot": "Aperçu du stock",
  "Recent seller listings and compatibility coverage.": "Annonces récentes et compatibilités.",
  "No inventory found.": "Aucun stock.",
  "stock: {n}": "stock : {n}",
  "price: {price}": "prix : {price}",
  "fitment rows: {n}": "compatibilités : {n}",
  "Please choose an image first.": "Choisissez d'abord une image.",
  "Upload failed": "Échec de l'envoi",
  "Upload product media": "Ajouter des photos",
  "Upload JPG, PNG, or WEBP images directly to R2.": "Images JPG, PNG ou WEBP.",
  "Uploading...": "Envoi…",
  "Upload image": "Envoyer l'image",
  "Upload complete": "Envoi terminé",
  "Use this URL when attaching images to a part.": "Utilisez ce lien pour ajouter l'image à une pièce.",
  "Key:": "Clé :",
  "Filename:": "Fichier :",
  "Type:": "Type :",
  "Uploaded preview": "Aperçu",
  "Page not found": "Page introuvable",
  "This seller portal route does not exist or is not ready yet.": "Cette page n'existe pas.",
  "Go to dashboard": "Tableau de bord",
  "Failed to load order details": "Impossible de charger la commande",
  "Loading order details...": "Chargement de la commande…",
  "Order not found": "Commande introuvable",
  "Order details": "Détail de la commande",
  "Review buyer information, line items, payment state, and shipping progress.": "Acheteur, articles, paiement et livraison.",
  "Back to orders": "Retour aux commandes",
  "Order status": "Statut de la commande",
  "Payment": "Paiement",
  "Shipping": "Livraison",
  "Total": "Total",
  "Line items": "Articles",
  "Products included in this order.": "Produits de cette commande.",
  "Part": "Pièce",
  "Unit price: {price}": "Prix unitaire : {price}",
  "Line total: {price}": "Total : {price}",
  "No line items available for this order yet.": "Aucun article pour cette commande.",
  "Order notes": "Notes de commande",
  "No notes attached to this order.": "Aucune note.",
  "Buyer information": "Acheteur",
  "Buyer name": "Nom de l'acheteur",
  "Phone": "Téléphone",
  "City": "Ville",
  "Address": "Adresse",
  "Status summary": "Statuts",
  "Order status:": "Commande :",
  "Payment status:": "Paiement :",
  "Shipping status:": "Livraison :",
  "Created at:": "Créée le :",
  "Failed to load seller orders": "Impossible de charger les commandes",
  "Loading seller orders...": "Chargement des commandes…",
  "Orders management": "Gestion des commandes",
  "Seller orders": "Commandes",
  "Review incoming orders, monitor statuses, and move into order details.": "Suivez vos commandes et leurs statuts.",
  "Total orders": "Commandes",
  "Pending": "En attente",
  "Shipped": "Expédiée",
  "Delivered": "Livrée",
  "Search order id, buyer, status...": "N° de commande, acheteur, statut…",
  "All statuses": "Tous les statuts",
  "Confirmed": "Confirmée",
  "Processing": "En préparation",
  "Cancelled": "Annulée",
  "Reset": "Réinitialiser",
  "{n} orders found": "{n} commande(s)",
  "No orders yet": "Aucune commande",
  "New seller orders will appear here when buyer activity starts.": "Vos commandes apparaîtront ici.",
  "Payment: {status}": "Paiement : {status}",
  "Buyer: {name}": "Acheteur : {name}",
  "Email: {email}": "E-mail : {email}",
  "Shipping: {status}": "Livraison : {status}",
  "Created: {date}": "Créée le : {date}",
  "View order": "Voir la commande",
  "Confirm exact engine code before sale.": "Confirmez le code moteur avant la vente.",
  "Add make/model/year compatibility rows after creation.": "Ajoutez les compatibilités marque/modèle/année après la création.",
  "Specify front / rear axle in compatibility details.": "Précisez avant / arrière dans les compatibilités.",
  "Brake fitment should match make/model/year precisely.": "Le freinage doit correspondre exactement à la marque, au modèle et à l'année.",
  "Include engine variant in fitment rows.": "Indiquez la motorisation.",
  "Filter compatibility converts better when SKU and engine are both clear.": "Un filtre se vend mieux avec un SKU et un moteur clairs.",
  "Add make/model/year ranges for the exact engine variants using this turbo.": "Ajoutez les années pour les moteurs exacts équipés de ce turbo.",
  "Brake parts convert better when compatibility rows and axle position are clear.": "Les pièces de frein se vendent mieux avec compatibilités et position claires.",
  "Filters need SKU and engine compatibility for stronger buyer confidence.": "Les filtres ont besoin d'un SKU et d'une compatibilité moteur.",
  "Add a clear part title first to unlock better suggestions.": "Ajoutez un titre clair pour avoir des suggestions.",
  "Failed to load part form data": "Impossible de charger le formulaire",
  "Part title is required.": "Le titre est obligatoire.",
  "Part slug is required.": "Le lien (slug) est obligatoire.",
  "Category is required.": "La catégorie est obligatoire.",
  "Price is required.": "Le prix est obligatoire.",
  "Enter the price in dirhams, e.g. 350 or 349,90.": "Prix en dirhams, ex. 350 ou 349,90.",
  "Enter the compare-at price in dirhams, e.g. 420.": "Prix barré en dirhams, ex. 420.",
  "Quantity is required.": "La quantité est obligatoire.",
  "Part created successfully.": "Pièce créée.",
  "Failed to create part": "Impossible de créer la pièce",
  "Loading part creation form...": "Chargement du formulaire…",
  "Create part": "Créer la pièce",
  "Add a new listing": "Nouvelle annonce",
  "Create a seller listing with core product data, stock, pricing, and fitment notes.": "Créez une annonce avec infos produit, stock, prix et compatibilité.",
  "Back to inventory": "Retour au stock",
  "Part details": "Détails de la pièce",
  "Fill in the essential fields for a clean seller listing.": "Remplissez les champs essentiels.",
  "Title": "Titre",
  "Bosch Front Brake Pads Set": "ex. Jeu de plaquettes avant Bosch",
  "Slug": "Lien (slug)",
  "Use slug": "Utiliser",
  "Brand": "Marque",
  "Select brand": "Choisir la marque",
  "Match": "Compatible",
  "Category": "Catégorie",
  "Select category": "Choisir la catégorie",
  "Suggest": "Suggérer",
  "Price (MAD)": "Prix (MAD)",
  "Compare-at price (MAD)": "Prix barré (MAD)",
  "Quantity": "Quantité",
  "Condition": "État",
  "New": "Nouveau",
  "Used": "Occasion",
  "Refurbished": "Reconditionné",
  "Status": "Statut",
  "Active": "Active",
  "Draft": "Brouillon",
  "Image URL": "Lien de l'image",
  "Description": "Description",
  "Describe the part, condition, and trust signals...": "Décrivez la pièce, son état…",
  "Fitment notes": "Notes de compatibilité",
  "Weight (kg)": "Poids (kg)",
  "Featured listing": "Annonce en vedette",
  "Creating...": "Création…",
  "Cancel": "Annuler",
  "Listing assistant": "Assistant d'annonce",
  "Suggestions based on your current inputs.": "Suggestions selon vos saisies.",
  "Suggested slug": "Lien suggéré",
  "Waiting for title": "En attente du titre",
  "Suggested category": "Catégorie suggérée",
  "No strong category signal yet": "Pas encore de catégorie évidente",
  "Suggested brand": "Marque suggérée",
  "No brand detected in title": "Aucune marque dans le titre",
  "Title suggestions": "Suggestions de titre",
  "Add a clearer title to unlock title cleanup suggestions.": "Ajoutez un titre plus clair pour avoir des suggestions.",
  "Use title": "Utiliser",
  "Fitment guidance": "Conseils de compatibilité",
  "Listings with stronger compatibility data usually rank better and convert better for vehicle-aware buyers.": "Les annonces avec compatibilités sont mieux classées et se vendent mieux.",
  "Compatibility suggestions": "Suggestions de compatibilité",
  "Quick notes you can insert into fitment notes before adding structured compatibility rows.": "Notes rapides à insérer avant d'ajouter les compatibilités.",
  "Add a clearer vehicle or part title to unlock compatibility suggestions.": "Ajoutez un véhicule ou un titre plus clair pour avoir des suggestions.",
  "Add to notes": "Ajouter aux notes",
  "Choose an image first.": "Choisissez d'abord une image.",
  "Create part failed": "Échec de la création",
  "Create part + upload image": "Créer la pièce + photo",
  "Upload product media to R2, then save the part in D1 in one flow.": "Ajoutez la photo et la pièce en une seule étape.",
  "Front Brake Pads Kit": "Kit de plaquettes avant",
  "Seller ID": "ID vendeur",
  "Category ID": "ID catégorie",
  "Brand ID": "ID marque",
  "Describe the part...": "Décrivez la pièce…",
  "Product image": "Photo du produit",
  "Upload first, then the image URL will be attached automatically.": "Envoyez d'abord la photo ; son lien sera ajouté automatiquement.",
  "Preview": "Aperçu",
  "Saving part...": "Enregistrement…",
  "Part created successfully": "Pièce créée",
  "ID:": "ID :",
  "Title:": "Titre :",
  "Slug:": "Lien :",
  "Price:": "Prix :",
  "Image:": "Image :",
  "No image": "Pas de photo",
  "Add make/model/year compatibility rows after saving changes.": "Ajoutez les compatibilités après l'enregistrement.",
  "Turbo parts perform better when engine variants and exact year ranges are explicit.": "Un turbo se vend mieux avec moteurs et années précis.",
  "Brake listings convert better when fitment rows and axle/position context are clear.": "Le freinage se vend mieux avec compatibilités et position claires.",
  "Filters should include SKU and engine compatibility for stronger buyer trust.": "Les filtres doivent indiquer SKU et moteur.",
  "Add or refine the title to unlock stronger listing suggestions.": "Précisez le titre pour avoir de meilleures suggestions.",
  "Failed to load edit form data": "Impossible de charger le formulaire",
  "Part not found": "Pièce introuvable",
  "Failed to load part": "Impossible de charger la pièce",
  "Part updated successfully.": "Pièce mise à jour.",
  "Failed to update part": "Impossible de mettre à jour la pièce",
  "Loading part editor...": "Chargement…",
  "Edit part": "Modifier la pièce",
  "Update your listing": "Modifier votre annonce",
  "Refine your seller listing, adjust stock, pricing, and improve product presentation.": "Ajustez votre annonce, le stock, le prix et la présentation.",
  "Edit your product data and keep the listing accurate.": "Gardez votre annonce exacte et à jour.",
  "PartHub didn't approve this listing": "PartHub n'a pas validé cette annonce",
  "PartHub archived this listing": "PartHub a archivé cette annonce",
  "Fix the issue and save: the listing goes back for review.": "Corrigez et enregistrez : l'annonce repart en vérification.",
  "Archived": "Archivée",
  "Save changes": "Enregistrer",
  "Suggestions based on your current listing fields.": "Suggestions selon votre annonce.",
  "Refine the title to unlock cleanup suggestions.": "Précisez le titre pour avoir des suggestions.",
  "Listings with clearer compatibility context usually rank better and reduce buyer hesitation.": "Des compatibilités claires améliorent le classement et rassurent l'acheteur.",
  "Quick notes you can insert into fitment notes before refining structured compatibility rows.": "Notes rapides à insérer avant d'ajuster les compatibilités.",
  "Refine the title with vehicle or part context to unlock compatibility suggestions.": "Précisez le véhicule ou la pièce dans le titre pour avoir des suggestions.",
  "Failed to load seller inventory": "Impossible de charger le stock",
  "Loading seller inventory...": "Chargement du stock…",
  "Inventory management": "Gestion du stock",
  "Your parts inventory": "Votre stock de pièces",
  "Search, review, and manage your part listings from one place.": "Cherchez et gérez vos annonces.",
  "+ Create part": "+ Nouvelle pièce",
  "Drafts": "Brouillons",
  "Low stock": "Stock faible",
  "Search title, SKU, brand, category...": "Titre, SKU, marque, catégorie…",
  "All stock states": "Tous les stocks",
  "In stock": "En stock",
  "Out of stock": "Rupture de stock",
  "{n} parts found": "{n} pièce(s)",
  "No parts yet": "Aucune pièce",
  "Create your first listing to start building your seller inventory.": "Créez votre première annonce.",
  "Unknown brand": "Marque inconnue",
  "Uncategorized": "Sans catégorie",
  "Not approved:": "Non validée :",
  "Archived:": "Archivée :",
  "Edit the listing and save it to send it for review again.": "Modifiez et enregistrez l'annonce pour la renvoyer en vérification.",
  "No description available.": "Pas de description.",
  "Failed to load request": "Impossible de charger la demande",
  "Enter a valid price in MAD": "Saisissez un prix valide en MAD",
  "Offer updated.": "Offre mise à jour.",
  "Offer sent to the buyer.": "Offre envoyée à l'acheteur.",
  "Could not send offer": "Impossible d'envoyer l'offre",
  "Withdraw your offer?": "Retirer votre offre ?",
  "Offer withdrawn.": "Offre retirée.",
  "Could not withdraw offer": "Impossible de retirer l'offre",
  "Request not found": "Demande introuvable",
  "← Back to requests": "← Retour aux demandes",
  "Hello {name}, this is about your PartHub request \"{part}\" ({ref}).": "Bonjour {name}, c'est au sujet de votre demande PartHub « {part} » ({ref}).",
  "Hello, this is about your PartHub request \"{part}\" ({ref}).": "Bonjour, c'est au sujet de votre demande PartHub « {part} » ({ref}).",
  "← All requests": "← Toutes les demandes",
  "OEM number": "Référence OEM",
  "Wanted condition": "État souhaité",
  "Buyer city": "Ville de l'acheteur",
  "Buyer's photos": "Photos de l'acheteur",
  "The buyer accepted your offer 🎉": "L'acheteur a accepté votre offre 🎉",
  "{price} · {condition}. Contact them to arrange the sale.": "{price} · {condition}. Contactez-le pour finaliser la vente.",
  "Your offer": "Votre offre",
  "Send an offer": "Envoyer une offre",
  "Price (MAD) *": "Prix (MAD) *",
  "e.g. 750": "ex. 750",
  "Condition *": "État *",
  "Warranty (months)": "Garantie (mois)",
  "Ready in (days)": "Prête sous (jours)",
  "Note to buyer": "Note pour l'acheteur",
  "Mileage, tested, original part, delivery options…": "Kilométrage, testée, pièce d'origine, livraison…",
  "Saving…": "Enregistrement…",
  "Update offer": "Mettre à jour l'offre",
  "Send offer": "Envoyer l'offre",
  "Withdraw offer": "Retirer l'offre",
  "The buyer sees your store name, price, condition and warranty. Their phone is shared with you only if they accept.": "L'acheteur voit le nom de votre boutique, le prix, l'état et la garantie. Son numéro ne vous est communiqué que s'il accepte.",
  "The buyer chose another offer. Thanks for answering!": "L'acheteur a choisi une autre offre. Merci d'avoir répondu !",
  "This request is no longer accepting offers.": "Cette demande n'accepte plus d'offres.",
  "Failed to load requests": "Impossible de charger les demandes",
  "Part requests": "Demandes de pièces",
  "Buyers looking for parts they couldn't find. Send an offer — if they accept, you get their contact.": "Des acheteurs cherchent des pièces introuvables. Envoyez une offre : s'ils acceptent, vous recevez leur contact.",
  "For my stock": "Pour mon stock",
  "All requests": "Toutes les demandes",
  "Search part, make, OEM…": "Pièce, marque, OEM…",
  "Showing requests for makes you have compatibility data for, or categories you sell in.": "Demandes pour les marques de vos compatibilités ou vos catégories.",
  "{n} waiting for your offer.": "{n} en attente de votre offre.",
  "No requests right now": "Aucune demande pour l'instant",
  "Add vehicle compatibility to your parts to get matched with more buyers, or browse all requests.": "Ajoutez des compatibilités à vos pièces pour recevoir plus de demandes, ou voyez toutes les demandes.",
  "New buyer requests will show up here.": "Les nouvelles demandes apparaîtront ici.",
  "Matches your stock": "Correspond à votre stock",
  "Your offer: {price}": "Votre offre : {price}",
  "1 offer so far": "1 offre pour l'instant",
  "{n} offers so far": "{n} offres pour l'instant",
  "Failed to load seller reviews": "Impossible de charger les avis",
  "Loading seller reviews...": "Chargement des avis…",
  "Reviews foundation": "Avis",
  "Seller reviews": "Avis clients",
  "Monitor buyer feedback, track rating quality, and review comments tied to your listings.": "Suivez les avis et les notes de vos acheteurs.",
  "Total reviews": "Avis",
  "Average rating": "Note moyenne",
  "5-star reviews": "Avis 5 étoiles",
  "Low ratings (≤2)": "Notes faibles (≤2)",
  "Search buyer, part, or review text...": "Acheteur, pièce ou texte…",
  "All ratings": "Toutes les notes",
  "5 stars": "5 étoiles",
  "4 stars": "4 étoiles",
  "3 stars": "3 étoiles",
  "2 stars": "2 étoiles",
  "1 star": "1 étoile",
  "{n} reviews found": "{n} avis",
  "No reviews yet": "Aucun avis",
  "Reviews will appear here once buyers start rating your listings.": "Les avis apparaîtront ici dès que les acheteurs noteront vos annonces.",
  "Part review": "Avis sur la pièce",
  "No written review content.": "Pas de commentaire.",
  "Failed to load store settings": "Impossible de charger les réglages",
  "Store display name is required.": "Le nom de la boutique est obligatoire.",
  "Store slug is required.": "L'adresse web est obligatoire.",
  "City is required.": "La ville est obligatoire.",
  "Store settings saved.": "Réglages enregistrés.",
  "Store created. PartHub will review it; meanwhile you can add your first parts.": "Boutique créée. PartHub va la vérifier ; en attendant, ajoutez vos premières pièces.",
  "Failed to save store settings": "Impossible d'enregistrer les réglages",
  "Loading store settings...": "Chargement des réglages…",
  "Manage your seller profile": "Gérez votre profil vendeur",
  "Create your store": "Créez votre boutique",
  "Complete your store identity so your listings and seller presence look stronger.": "Complétez votre profil pour inspirer confiance.",
  "Name, web address and city are enough to start. You can add the rest later.": "Le nom, l'adresse web et la ville suffisent pour commencer. Le reste plus tard.",
  "Store readiness": "État de la boutique",
  "Store profile": "Profil de la boutique",
  "These details define how your seller presence appears across the marketplace.": "Ces informations s'affichent sur la plateforme.",
  "Store display name": "Nom de la boutique",
  "Store web address": "Adresse web de la boutique",
  "WhatsApp": "WhatsApp",
  "Tell buyers about your store, specialties, and trust signals...": "Présentez votre boutique et vos spécialités…",
  "Logo URL": "Lien du logo",
  "Banner URL": "Lien de la bannière",
  "Save store settings": "Enregistrer",
  "Create store": "Créer la boutique",
  "Preview snapshot": "Aperçu",
  "Store banner": "Bannière",
  "Store logo": "Logo",
  "Your store name": "Nom de votre boutique",
  "City not set": "Ville non renseignée",
  "Your store description preview will appear here.": "L'aperçu de votre description apparaîtra ici.",
  "What helps most": "Ce qui aide le plus",
  "A clear store name and description improve seller credibility.": "Un nom et une description clairs inspirent confiance.",
  "City and phone make your seller profile feel more complete.": "La ville et le téléphone complètent votre profil.",
  "Logo and banner URLs help your store look more professional.": "Un logo et une bannière donnent un air professionnel.",
  "Create your store to start selling": "Créez votre boutique pour commencer à vendre",
  "It takes a few minutes: store name, city and a contact number.": "Quelques minutes suffisent : nom, ville et numéro de contact.",
  "Finish setting up your store": "Terminez la configuration",
  "Complete the required steps below, then PartHub reviews your store.": "Terminez les étapes obligatoires, puis PartHub vérifie votre boutique.",
  "Your store is waiting for approval": "Votre boutique est en attente de validation",
  "PartHub is reviewing your store. You can keep adding parts; they go live once your store is approved.": "PartHub vérifie votre boutique. Continuez à ajouter des pièces : elles seront en ligne après validation.",
  "Your store is live": "Votre boutique est en ligne",
  "Buyers can find your parts and send you requests.": "Les acheteurs voient vos pièces et vous envoient des demandes.",
  "Your store is suspended": "Votre boutique est suspendue",
  "Your parts are hidden from buyers. Contact PartHub support to restore your store.": "Vos pièces sont masquées. Contactez le support PartHub pour la réactiver.",
  "Your store was not approved": "Votre boutique n'a pas été validée",
  "Update your store details and contact PartHub support to ask for a new review.": "Mettez à jour vos informations et contactez le support pour une nouvelle vérification.",
  "Edit store": "Modifier la boutique",
  "New or used": "Neuve ou occasion",
  "Store name, web address and city.": "Nom, adresse web et ville.",
  "Add a phone or WhatsApp number": "Ajoutez un numéro de téléphone ou WhatsApp",
  "Buyers who accept your offers contact you on this number.": "Les acheteurs qui acceptent vos offres vous contactent sur ce numéro.",
  "Add number": "Ajouter le numéro",
  "Describe your store": "Décrivez votre boutique",
  "What you sell, which brands, delivery options (at least 40 characters).": "Ce que vous vendez, les marques, la livraison (40 caractères minimum).",
  "Write description": "Écrire la description",
  "List your first part": "Publiez votre première pièce",
  "Title, price in MAD, condition and stock.": "Titre, prix en MAD, état et stock.",
  "Add part": "Ajouter une pièce",
  "Add photos to your parts": "Ajoutez des photos",
  "Listings with photos get far more clicks.": "Les annonces avec photos sont bien plus consultées.",
  "Open inventory": "Ouvrir le stock",
  "Add vehicle compatibility": "Ajoutez des compatibilités",
  "Make, model and years, so buyers searching for their car find your parts.": "Marque, modèle et années, pour que les acheteurs trouvent vos pièces.",
  "Add a store logo": "Ajoutez un logo",
  "Shown on your public store page.": "Affiché sur votre page boutique.",
  "Add logo": "Ajouter le logo",
  "Paid": "Payée",
  "Unpaid": "Non payée",
  "Failed": "Échoué",
  "Refunded": "Remboursée",
  "Rejected": "Refusée",
  "Suspended": "Suspendue",
  "Approved": "Validée",
  "Open for offers": "Ouverte",
  "Closed": "Fermée",
  "Fulfilled": "Pourvue",
  "Expired": "Expirée",
  "Accepted": "Acceptée",
  "Declined": "Refusée",
  "Unknown": "Inconnu",
  "Not shipped": "Non expédiée",
  "In transit": "En transit",
  "1 offer so far · posted {date}": "1 offre pour l'instant · publiée le {date}",
  "{n} offers so far · posted {date}": "{n} offres pour l'instant · publiée le {date}",
};
